import api from "../../../";
import type { ApiResponse } from "../../../types";
import type { PaginatedResponse } from "../types";
import type {
  CommunityQuestion,
  GetCommunityQuestionByIdParams,
  GetCommunityQuestionsParams,
  GetMyCommunityQuestionsParams,
  SearchCommunityQuestionsParams,
} from "./types";

type ListQuestionApiResult = {
  data?: CommunityQuestion[];
  success?: boolean;
  message?: string;
};

const normalizeQuestionsResults = (items: Array<CommunityQuestion | ListQuestionApiResult>): CommunityQuestion[] => {
  if (!Array.isArray(items)) return [];

  return items.flatMap((item) => {
    if ("id" in item) return [item as CommunityQuestion];
    return Array.isArray(item.data) ? item.data : [];
  });
};

export const getCommunityQuestions = async ({ params }: GetCommunityQuestionsParams = {}): Promise<PaginatedResponse<CommunityQuestion>> => {
  return await api.get<PaginatedResponse<CommunityQuestion | ListQuestionApiResult>>("/admin/sepehr/questions/", params ? { params } : {})
    .then((res) => ({
      ...res.data,
      results: normalizeQuestionsResults(res.data.results || []),
    }))
    .catch(() => ({
      count: 0,
      next: null,
      previous: null,
      results: [],
    }));
};

export const getCommunityQuestionById = async ({ id }: GetCommunityQuestionByIdParams): Promise<CommunityQuestion | null> => {
  return await api.get<ApiResponse<CommunityQuestion>>(`/admin/sepehr/questions/${id}/`)
    .then((res) => res.data.data)
    .catch(() => null);
};

export const getMyCommunityQuestions = async ({ id }: GetMyCommunityQuestionsParams = {}): Promise<CommunityQuestion[]> => {
  return await api.get<ApiResponse<CommunityQuestion[]>>("/community/questions/me/", {
    params: id ? { id } : undefined,
  })
    .then((res) => res.data.data)
    .catch(() => []);
};

export const searchCommunityQuestions = async ({ params }: SearchCommunityQuestionsParams): Promise<CommunityQuestion[]> => {
  return await api.get<ApiResponse<CommunityQuestion[]>>("/admin/sepehr/questions/search/", { params })
    .then((res) => res.data.data)
    .catch(() => []);
};

